<template>
  <div class="Alpha-Post-Cover">
    <img class="Alpha-Post-Cover__image" :src="pon_chat" v-if="get_isPon" alt="img"/>
    <img class="Alpha-Post-Cover__image" :src="get_cover" v-else-if="get_isCover"  alt="img"/>
    <img class="Alpha-Post-Cover__image" :src="get_userAvatar" v-else-if="get_isUserAvatar"  alt="img"/>
    <PostAudioButton :post="get_postData" v-else-if="get_isPodcast" />
    <div class="Alpha-Post-Cover__wrapper" v-else>
      <XIcon v-if="get_isX" />
      <AlphaIcon v-else />
    </div>
  </div>
</template>

<script setup>
  import { defineProps, computed } from 'vue';
  import { Props } from './scripts/props.js';
  import { useStore } from 'vuex';
  import { POST_TYPES } from '@shared/constants/posts/postTypes.js';
  //---------------------------
  import XIcon from './icons/xIcon.vue';
  import AlphaIcon from './icons/AlphaIcon.vue';
  import PostAudioButton from '@/Groups/Audioplayer/public/modules/PostAudioButton/PostAudioButton.vue';
  //---------------------------
  const props = defineProps(Props());
  const store = useStore();
  //---------------------------
  const pon_chat = 'https://dropscapital.fra1.cdn.digitaloceanspaces.com/static/images/pon_chat.webp';
  //---------------------------
  const get_postData = computed(() => store.state.ContentSystem.Alpha.list[props.postId] || props.post);
  //Пост отновистся к каналу 'Обзор X'
  const get_isX = computed(() => get_postData.value.channels?.some(channel => channel.slug === 'обзор-x'));
  //Пост отновистся к каналу 'Выжимка PON'
  const get_isPon = computed(() => get_postData.value.channels?.some(channel => channel.slug === 'выжимка-pon'));
  //Это подкаст?
  const get_isPodcast = computed(() => get_postData.value.section_name === POST_TYPES.PODCAST);
  //Аватар является ковером для поста
  const get_isCover = computed(() => get_postData.value.images_list.length > 0 && !get_isX.value && !get_isPon.value);
  //Отобразить ли автатарку пользователя?
  const get_isUserAvatar = computed(() => get_postData.value.section_name === POST_TYPES.OPINION && !get_isCover.value);
  //Получим аватарку пользователя для cover, для мнения без картинок
  const get_userAvatar = computed(() => get_postData.value.author.avatar );
  //Получить cover для поста
  const get_cover = computed(() => get_postData.value.images_list[0]);
</script>

<style lang="scss">
  @import "./styles/_conf";
</style>
